import "./App.css";
import { useState, useMemo, useEffect } from "react";
import configureStore from "./store/configureStore";
import { Provider, useSelector,useDispatch } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import GlobalFonts from "./fonts/fonts";
import PathSwitches from "./components/PathSwitches";
import Navigation from "./components/Navigation";
import { ToastContainer } from "react-toastify";
import FullScreenDiv from "./general/FullScreenDiv";
import * as theme from "./theme";
import { getShowNavigationBar } from "./store/components";
import LloydsPdfComponent from "./components/CustomPdfs/lloyds/LloydsPdfComponent";
import { useLocation } from "react-router-dom";
import { updateBrokerLanguagePreference } from "./store/broker";
import NavigationHeader from "./components/NavigationHeader";


const store = configureStore();

function App() {
  return (
    <Provider store={store}>
      <GlobalFonts />
      <ToastContainer
        toastStyle={{
          backgroundColor: theme.COLORS.secondary_orange,
          color: "white",
          fontFamily: "GibsonRegular",
          letterSpacing: 1,
        }}
        position={"top-center"}
      />
      <Router>
        <FullScreenDivContent></FullScreenDivContent>
      </Router>
      {/* <LloydsPdfComponent /> */}
    </Provider>
  );
}

const FullScreenDivContent = () => {

  const location = useLocation();
  const { search } = useLocation();
  const dispatch = useDispatch();
  const searchquery = new URLSearchParams(search);
  const urlLanguagePref = searchquery.get("languagepreference");

  // Check localStorage/sessionStorage for saved language preference
  const savedLanguage = localStorage.getItem("language") || sessionStorage.getItem("language");

  // Priority: URL parameter > saved preference > default "en"
  const languageToUse = urlLanguagePref || savedLanguage || "en";

  // Only dispatch if we have a valid language
  if (languageToUse) {
    dispatch(updateBrokerLanguagePreference(languageToUse));
  }
  // const showNavigationBar = useSelector(getShowNavigationBar);

  useEffect(() => {
    const dispatchLanguageUpdate = async () => {
      // Check localStorage/sessionStorage
      const savedLanguage = localStorage.getItem("language") || sessionStorage.getItem("language");
      const languageToUse = urlLanguagePref || savedLanguage || "en";

      try {
        await dispatch(updateBrokerLanguagePreference(languageToUse));
      } catch (error) {
        console.error("Error dispatching language preference update:", error);
      }
    };
    dispatchLanguageUpdate();
  }, [urlLanguagePref, dispatch]); // Add urlLanguagePref and dispatch as dependencies

  const showNavigationBarFromStore = useSelector(getShowNavigationBar);
  // const navHeight = showNavigationBarFromStore ? theme.SCALES.navheight : "0%";
  const navHeight = "10vh";
  // Check if the current path starts with /customPdf
  const isCustomPdfPath = location.pathname.startsWith("/customPdf");
  const ishomepage = location.pathname == '/homepage';
  // Determine if the navigation bar should be shown
  const showNavigationBar = !isCustomPdfPath && showNavigationBarFromStore;
  let navBackgroundColor = window.location.pathname == "/" ? null : theme.COLORS.tertiary_lightbackground;
  return (
    <FullScreenDiv>
      {showNavigationBar ? (
        <div
          style={{
            display: ishomepage ? "none": undefined,
            width: "100%",
            // height: navHeight,
            backgroundColor: navBackgroundColor,
          }}
        >
          {/* <Navigation></Navigation> */}
          < NavigationHeader />
        </div>
      ) : null}
      <div
        style={{
          width: "100%",
          height: `88vh`,
          backgroundColor: navBackgroundColor,
        }}
      >
        <PathSwitches></PathSwitches>
      </div>
    </FullScreenDiv>
  );
};

export default App;
